import { requestWithAuth } from './config';

const resource = '/statistics/user-actions';

export const getAll = () => {
  return requestWithAuth.get(resource);
};
